<div class="h-screen w-full flex flex-row overflow-hidden" *ngIf="!externalRequest">

  <sigecom-side-nav [@slideOpenClose]="hideSideNavAnimation" *ngIf="!isLoginPage && !environment.devBeta && (isMobile || !(fullscreen$ | async))"/>

  <div class="h-full min-h-0 w-full flex flex-col overflow-hidden">
    <sigecom-header #appHeader class="w-full sticky top-0 z-100" *ngIf="!isLoginPage && !(fullscreen$ | async)" />

    <div class="app-route-scroll bg-sigecom-container flex-1 min-h-0 relative overflow-x-hidden overflow-y-auto">
      <router-outlet></router-outlet>
    </div>

    <sigecom-footer *ngIf="!isLoginPage && !(fullscreen$ | async)"/>

    <sigecom-snackbar/>
  </div>

</div>

<sigecom-confirmation-modal />

<sigecom-media-displayer-modal/>
<router-outlet *ngIf="externalRequest"></router-outlet>
